import React, { useEffect, useMemo, useCallback } from 'react';
import { Field } from 'formik';
import { useFormikContext } from 'formik';

import { FormLabelUI, SelectUI } from '../Interface';
import { getDynVal, getIndex } from '../../utils/DynHelper';

const DynComboInput = ({ name, disabled, fieldData, selectedValues, showLabel }) => {
  const { property } = fieldData;
  const { propertyOption } = property;
  const { values, setFieldValue } = useFormikContext();

  const formattedOptions = useMemo(
    () =>
      propertyOption.map((option) => ({
        label: option.name,
        value: option.id,
      })),
    [propertyOption]
  );

  const dynVal = useMemo(
    () => getDynVal(selectedValues.dynamicProperties, name),
    [selectedValues.dynamicProperties, name]
  );

  useEffect(() => {
    const setterVal = dynVal?.comboBoxVal ?? '';

    setFieldValue(name, setterVal);
  }, [dynVal, name, setFieldValue]);

  const handleChange = useCallback(
    (e) => {
      setFieldValue(name, e.target.value);
    },
    [name, setFieldValue]
  );

  return (
    <Field
      name={name}
      type={'select'}
      as={SelectUI}
      fullWidth
      value={values?.dynamicFields?.[getIndex(name)] ?? ''}
      variant="standard"
      disabled={disabled}
      option={formattedOptions}
      onChange={handleChange}
      label={showLabel ? <FormLabelUI text={property?.name} /> : undefined}
    />
  );
};

export default DynComboInput;
